module.exports = __webpack_public_path__ + "media/images/icon__checkmark--white@2x-2f7b6799442018dd48f9591ad7da2464.png";